import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PosSessionsState } from './pos-sessions.state';

export const selectPosSessionsState = createFeatureSelector<PosSessionsState>('adminPosSessions');

export const selectAllPosSessions = createSelector(
  selectPosSessionsState,
  (state) => state.sessions,
);

export const selectPosSessionsLoading = createSelector(
  selectPosSessionsState,
  (state) => state.loading,
);

export const selectCurrentSessionLoading = createSelector(
  selectPosSessionsState,
  (state) => state.currentSessionLoading,
);

export const selectPosSessionsPagination = createSelector(
  selectPosSessionsState,
  (state) => ({
    total: state.total,
    page: state.page,
    limit: state.limit,
    totalPages: state.totalPages,
  }),
);

export const selectPosSessionsParams = createSelector(
  selectPosSessionsState,
  (state) => state.params,
);

export const selectCurrentPosSession = createSelector(
  selectPosSessionsState,
  (state) => state.currentSession,
);

export const selectOverallPosStats = createSelector(
  selectPosSessionsState,
  (state) => state.overallStats,
);

export const selectSelectedSessionStats = createSelector(
  selectPosSessionsState,
  (state) => state.selectedSessionStats,
);

export const selectStatsLoading = createSelector(
  selectPosSessionsState,
  (state) => state.statsLoading,
);

export const selectPosSessionsError = createSelector(
  selectPosSessionsState,
  (state) => state.error,
);

export const selectHelpers = createSelector(
  selectPosSessionsState,
  (state) => state.helpers,
);

export const selectHelpersLoading = createSelector(
  selectPosSessionsState,
  (state) => state.helpersLoading,
);

